import React, { Component } from "react";
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import { spin, stop } from '../../store/spinner';
import { getArrays, intersect } from '../../lib';
import { setCheckoutPlanParams } from '../../store/checkoutPlanParams';
import { setCheckoutMealPlan, updateCheckoutMealPlan, deleteCheckoutMealPlan } from '../../store/checkoutMealPlan';
import { setPlanParams } from '../../store/planParams';
import { setMealPlan } from '../../store/mealPlan';
import moment from 'moment';
import { setModal, clearModal } from '../../store/modal';
import { browserHistory } from "react-router";
import PaperButton from 'react-paper-button';

class RenewPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customDefaultDish: undefined
    };
  }

  componentDidMount() {
    const { checkoutPlanParams, user, planParams, dataArray } = this.props;
    const { id: checkout_id } = checkoutPlanParams;

    if (checkout_id) browserHistory.push('/checkout/menus');

    this.listener = ({ type, data, message }) => {
      this.props.stop();
      switch (type) {
        case 'getMealplanOk':
          if (data.planParams.userId === user.user_id) {
            this.props.setPlanParams(data.planParams);
            this.props.setMealPlan(data.mealPlan);
            this.getDefaultDishes(data.planParams.diet, data.planParams.mealType);
            this.setCheckOutFromPlan(data.planParams);
          }
          break;
        case 'getPendingOk':
          if (data.planParams !== undefined) {
            const includedDays = this.getIncludeDays(data.planParams['exclude_week_day']);
            const startDate = this.getinitialDate(includedDays, data.planParams['start_date']);
            this.props.setCheckoutPlanParams({
              ...data.planParams,
              mealTypes: data.planParams['mealTypes'].map(val => String(val)),
              date: moment.unix(startDate).format('YYYY-MM-DD')
            });
            this.props.setCheckoutMealPlan(data.mealPlan);
          } else {
            if (planParams.id !== undefined) {
              this.setCheckOutFromPlan(planParams);
            } else {
              this.props.spin();
              this.getPlanInfo();
            }
          }
          break;
        default:
          console.log(data);
          console.log(message);
          break;
      }
    };

    this.props.socket.on('mobile_checkout', this.listener);
    this.props.socket.on('profile', this.listener);

    const types = [
      'dietMobileList',
      'typeList',
      'planDayRange',
      'daysRangeMob',
      'mealtypeMobCombinations',
      'productsList',
      'ingredientList'
    ].filter(el => !(el in dataArray));

    if (types.length) {
      this.props.spin();
      getArrays(this.props.socket, types);
    }

    if (planParams.id !== undefined) {
      this.getDefaultDishes(planParams.diet, planParams.mealType);
    }

    this.props.spin();
    this.getPending(user.user_id);
  }

  componentWillUnmount() {
    this.props.socket.removeListener('mobile_checkout', this.listener);
    this.props.socket.removeListener('profile', this.listener);
  }

  getPending = user_id => {
    this.props.socket.emit('mobile_checkout', { type: 'getPending', data: { user_id } });
  };

  getPlanInfo = orderId => {
    const { user } = this.props;
    this.props.socket.emit('profile', {
      type: 'getForDashboard',
      data: { orderId: orderId, userId: user.user_id, subtype: 'getMealplan' }
    });
  };

  getDefaultDishes = (dietId, types) => {
    if (dietId !== undefined && types !== undefined) {
    //   const { typeList } = this.props.dataArray || {};
    //   const childTypes = types
    //     .map(val => {
    //       const { children } = typeList[+val] || {};
    //       return children != null ? children.id : null;
    //     })
    //     .filter(el => el != null);

      this.props.spin();
      this.props.socket.emit('default_dishes', { type: 'get', data: { dietId, types } });
      this.props.socket.emit('custom_plan', { type: 'get', data: { diet_id: dietId, mealTypes: types } });
      this.props.socket.emit('default_dish_sides', { type: 'get', data: { dietId: dietId, types: types } });
      this.props.socket.emit('custom_plan_sides', { type: 'get', data: { diet_id: dietId, mealTypes: types } });
    }
  };

  checkIsAllergiesOrDislike = (productsList, allergies, dislikes, dishid) => {
    const { ingredients } = productsList ? productsList[dishid] || {} : {};
    let is_allergies = false;
    if (ingredients !== undefined && ingredients.length > 0) {
      if (allergies.length > 0) {
        is_allergies = intersect(ingredients, allergies).length;
      }
      if (dislikes.length > 0 && !is_allergies) {
        is_allergies = intersect(ingredients, dislikes).length;
      }
      if (!is_allergies) {
        return dishid;
      }
      return null;
    } else {
      return dishid;
    }
  };

  fillDefaults = (checkoutMealPlan, defaultDishes) => {
    const { user, customPlans, dataArray, checkoutPlanParams, mealPlan } = this.props;
    const { productsList } = dataArray;
    const { mealTypes: types } = checkoutPlanParams || {};
    const { customDefaultDish } = this.state;

    const getDish = (date, type, existDish) => {
      const day = moment.unix(date).date() - 1;
      if (customDefaultDish && customDefaultDish[day] && customDefaultDish[day][type]) {
        return +customDefaultDish[day][type];
      }
      const sameDayDish = Object.values(existDish);
      const plan = customPlans.find(el => +el.mealType_id === +type) || {};
      let dish = +(defaultDishes[+type] || {})[day] || null;

      let prodKeys = (plan.data || {})[day] || [];
      const { allergies, dislikes, dishdislikes, eliminate_groups } = user;

      let is_allergies = this.checkIsAllergiesOrDislike(productsList, allergies, dislikes, dish);

      if (eliminate_groups.length > 0 && is_allergies) {
        const { group, spicy } = productsList[dish] || {};
        is_allergies = intersect(group, eliminate_groups).length > 0 ? null : dish;
        if (is_allergies) {
          is_allergies = eliminate_groups.indexOf(14) > -1 && spicy === 1 ? null : dish;
        }
      }

      if (dishdislikes.length > 0 && is_allergies) {
        is_allergies = dishdislikes.indexOf(dish) > -1 ? null : dish;
      }
      if (sameDayDish.length > 0 && is_allergies) {
        is_allergies = sameDayDish.indexOf(dish) > -1 ? null : dish;
      }

      if (is_allergies != null) {
        return +dish;
      } else {
        prodKeys =
          prodKeys &&
          prodKeys.filter(dishId => {
            const { group, spicy } = productsList[dishId] || {};
            let isEliminate = true;
            if (eliminate_groups.length > 0) {
              isEliminate = !intersect(group, eliminate_groups).length;
              if (isEliminate) {
                isEliminate = !(eliminate_groups.indexOf(14) > -1 && spicy === 1);
              }
            }
            if (dishdislikes.length > 0 && isEliminate) {
              isEliminate = !(dishdislikes.indexOf(+dishId) > -1);
            }
            return +isEliminate;
          });

        var validDish = prodKeys.find((dishId, idx) => {
          if (dishId !== dish) {
            let is_allergies = this.checkIsAllergiesOrDislike(productsList, allergies, dislikes, dishId);
            if (sameDayDish.length > 0 && is_allergies) {
              is_allergies = sameDayDish.indexOf(dishId) > -1 ? null : dishId;
            }
            if (is_allergies != null || prodKeys.length - 1 === idx) {
              return +dishId;
            }
          }
        });
        return validDish !== undefined ? validDish : +dish;
      }
    };

    return (
      checkoutMealPlan &&
      types &&
      Object.keys(checkoutMealPlan).reduce((acc, date) => {
        const dayData = types.reduce((acc, type) => {
          return { ...acc, [+type]: getDish(date, type, acc) };
        }, {});
        return { ...acc, [+date]: dayData };
      }, {})
    );
  };

  fillPlanDates = (startDate, count, excludedDays) => {
    const includedDays = this.getIncludeDays(excludedDays);
    let dates = {};
    if (count > 0 && startDate) {
      for (let i = 0; i < count; i++) {
        startDate = moment
          .unix(this.getinitialDate(includedDays, i === 0 ? startDate : startDate + 3600 * 24))
          .unix();
        dates[startDate] = {};
      }
    }
    return dates;
  };

  getinitialDate = (includedDays, startDate) => {
    var initialDate = moment.unix(startDate);
    if (includedDays.includes(initialDate.weekday())) {
      return startDate;
    } else {
      return this.getinitialDate(includedDays, startDate + 3600 * 24);
    }
  };

  getIncludeDays = excludedDays => {
    excludedDays = excludedDays ? excludedDays : [];
    return Array(7)
      .fill(0)
      .map((el, key) => key)
      .filter(el => !excludedDays.includes(String(el)));
  };

  setExistMealPlanMenu = () => {
    const { action } = this.props.params;
    const { mealPlan } = this.props;
    if (action === 'samemenu' && mealPlan) {
      const cdefaultDish = Object.keys(mealPlan).reduce((acc, date) => {
        const day = moment.unix(date).date() - 1;
        const dayData = Object.keys(mealPlan[date]).reduce((acc, type) => {
          return { ...acc, [+type]: mealPlan[date][type] };
        }, {});
        return { ...acc, [+day]: dayData };
      }, {});
      this.setState({ customDefaultDish: cdefaultDish });
    }
  };

  setCheckOutFromPlan = plandetails => {
    this.setExistMealPlanMenu();
    if (plandetails.id !== undefined) {
      delete plandetails.id;
      delete plandetails.checkout_id;
      delete plandetails.status;
      delete plandetails.payment_method_id;
      delete plandetails.payment_data;
      delete plandetails.detailedPrices;

      const includedDays = this.getIncludeDays(plandetails['exclude_week_day']);
      const startDate = this.getinitialDate(includedDays, plandetails['end_date'] + 3600 * 24);

      this.props.setCheckoutPlanParams({
        ...plandetails,
        mealTypes: plandetails['mealType'].map(val => parseInt(val)),
        date: moment.unix(startDate).format('YYYY-MM-DD'),
        isRenew: true,
        diet_id: plandetails.diet,
        exclude_week_day: plandetails.exclude_week_day.map(val => String(val))
      });

      let checkoutMealPlanData = this.fillPlanDates(startDate, plandetails['days_count'], plandetails['exclude_week_day']);
      if (checkoutMealPlanData) {
        let checkoutMealPlan = this.fillDefaults(checkoutMealPlanData, this.props.defaultDishes);
        this.props.setCheckoutMealPlan(checkoutMealPlan);

        if (checkoutMealPlan !== undefined && Object.keys(checkoutMealPlan).length > 0) {
          if (this.props.checkoutPlanParams.id !== undefined) {
            browserHistory.push('/checkout');
          }
        }
      }
    }
  };

  render() {
    const { checkoutPlanParams } = this.props;
    const { id: checkout_id } = checkoutPlanParams;

    return (
      <div className="main-holder checkout-process-con wrap-progress-page">
        <div className="container checkout-process">
          {!checkout_id && (
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', paddingTop: '20px' }}>
              <h2 style={{ fontSize: 28, textTransform: 'capitalize', marginBottom: 15, textAlign: 'center' }}>
                Renew Your Meal Plan
              </h2>
              <PaperButton
                onClick={() => {
                  browserHistory.push('/checkout');
                }}
                className={'button-small transition continue'}
              >
                <span>Yes, continue</span>
              </PaperButton>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const actions = dispatch => ({
  setCheckoutPlanParams: obj => dispatch(setCheckoutPlanParams(obj)),
  setPlanParams: obj => dispatch(setPlanParams(obj)),
  setMealPlan: obj => dispatch(setMealPlan(obj)),
  setModal: obj => dispatch(setModal(obj)),
  clearModal: () => dispatch(clearModal()),
  spin: () => dispatch(spin()),
  stop: () => dispatch(stop()),
  setCheckoutMealPlan: obj => dispatch(setCheckoutMealPlan(obj)),
  updateCheckoutMealPlan: (date, obj) => dispatch(updateCheckoutMealPlan(date, obj)),
  deleteCheckoutMealPlan: date => dispatch(deleteCheckoutMealPlan(date))
});

const props = state => ({
  dataArray: state.dataArray,
  user: state.user,
  checkoutPlanParams: state.checkoutPlanParams,
  checkoutMealPlan: state.checkoutMealPlan,
  planParams: state.planParams,
  mealPlan: state.mealPlan,
  defaultDishes: state.defaultDishes,
  customPlans: state.customPlans
});

export default socketConnect(connect(props, actions)(RenewPlan));
